import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const auth = useAuth();
  const location = useLocation();

  // Show nothing while auth is loading to prevent flash redirects
  if (auth.isLoading) {
    return null;
  }

  if (!auth.isAuthenticated) {
    // Redirect to login while saving the attempted URL
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 